var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.99967C10.9167 4.99967 11.6667 5.74967 11.6667 6.66634C11.6667 7.58301 10.9167 8.33301 10 8.33301C9.08337 8.33301 8.33337 7.58301 8.33337 6.66634C8.33337 5.74967 9.08337 4.99967 10 4.99967ZM10 12.4997C12.25 12.4997 14.8334 13.5747 15 14.1663V14.9997H5.00004V14.1747C5.16671 13.5747 7.75004 12.4997 10 12.4997ZM10 3.33301C8.15837 3.33301 6.66671 4.82467 6.66671 6.66634C6.66671 8.50801 8.15837 9.99967 10 9.99967C11.8417 9.99967 13.3334 8.50801 13.3334 6.66634C13.3334 4.82467 11.8417 3.33301 10 3.33301ZM10 10.833C7.77504 10.833 3.33337 11.9497 3.33337 14.1663V16.6663H16.6667V14.1663C16.6667 11.9497 12.225 10.833 10 10.833Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermIdentity);
export default __webpack_public_path__ + "static/media/perm_identity.eff9ab3ab9900ca716a3aca8b554890c.svg";
export { ForwardRef as ReactComponent };